module.exports = __webpack_public_path__ + "static/media/icon-q.35dc855d.svg";